module.exports = __webpack_public_path__ + "media/images/thumb/multiselect-switch-d19dbaed6cba3f8bff80ec95cd9bf67c.png";